import type { GridCellParams } from "@mui/x-data-grid";
import { Filters } from "consts/openBanking";
import { when } from "util/support";
import { useSimpleSwitch } from "ui/widgets/Table";
import { RecipientTooltipTitle } from "ui/forms/OpenBanking";

type UseToggleEnabledOpenBankingResourceArg =
    & Parameters<typeof useSimpleSwitch>[0]
    & {
        readonly forFields?: string[];
    };

export const useToggleEnabledOpenBankingResource = ({
    forFields = [Filters.isEnabled],
    ...restProps
}: UseToggleEnabledOpenBankingResourceArg): ReturnType<typeof useSimpleSwitch> => {
    const simpleSwitch = useSimpleSwitch(restProps);

    const getCellProps = (params: GridCellParams) => {
        const props = simpleSwitch.getCellProps(params);

        const { row, field, value } = params;

        return {
            ...props,
            ...when(
                !row[Filters.recipients_exist] && forFields.includes(field),
                {
                    disabled: !value,
                    TooltipProps: {
                        title: (
                            <RecipientTooltipTitle />
                        )
                    }
                }
            )
        };
    };

    return {
        ...simpleSwitch,
        getCellProps
    };
};

export default useToggleEnabledOpenBankingResource;
